import { render } from "./static.vue?vue&type=template&id=40bbd3f0&scoped=true"
const script = {}

import "./static.vue?vue&type=style&index=0&id=40bbd3f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40bbd3f0"

export default script